import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGearIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1244_8615)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				opacity: .2,
				d: "M21.5248 9.93747L19.0966 8.58747C18.9293 8.23061 18.7317 7.88873 18.506 7.5656L18.5529 4.78123C17.5227 3.84237 16.3007 3.13863 14.9716 2.71873L12.5904 4.14373C12.1971 4.1156 11.8024 4.1156 11.4091 4.14373L9.01852 2.70935C7.69362 3.13704 6.47569 3.84351 5.44664 4.78123L5.49352 7.5656C5.26782 7.88873 5.07022 8.23061 4.90289 8.58747L2.46539 9.93747C2.17312 11.2973 2.17632 12.704 2.47477 14.0625L4.90289 15.4125C5.07221 15.7713 5.26971 16.1161 5.49352 16.4437L5.44664 19.2187C6.47685 20.1576 7.6988 20.8613 9.02789 21.2812L11.4091 19.8562C11.8024 19.8844 12.1971 19.8844 12.5904 19.8562L14.981 21.2906C16.3059 20.8629 17.5238 20.1564 18.5529 19.2187L18.506 16.4344C18.7317 16.1112 18.9293 15.7693 19.0966 15.4125L21.5341 14.0625C21.8312 12.7032 21.828 11.2954 21.5248 9.93747ZM11.9998 16.5C11.1097 16.5 10.2397 16.2361 9.4997 15.7416C8.75968 15.2471 8.1829 14.5443 7.84231 13.722C7.50171 12.8998 7.4126 11.995 7.58623 11.1221C7.75987 10.2492 8.18845 9.44733 8.81779 8.81799C9.44712 8.18866 10.2489 7.76008 11.1219 7.58644C11.9948 7.41281 12.8996 7.50192 13.7218 7.84252C14.5441 8.18311 15.2469 8.75989 15.7414 9.49991C16.2358 10.2399 16.4998 11.11 16.4998 12C16.4998 13.1934 16.0257 14.338 15.1817 15.182C14.3378 16.0259 13.1932 16.5 11.9998 16.5Z",
				fill: "#1557b5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z",
				stroke: "#0f172b",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.506 7.5656C18.7317 7.88873 18.9293 8.23061 19.0966 8.58747L21.5248 9.93747C21.828 11.2954 21.8312 12.7032 21.5341 14.0625L19.0966 15.4125C18.9293 15.7693 18.7317 16.1112 18.506 16.4344L18.5529 19.2187C17.5238 20.1564 16.3059 20.8629 14.981 21.2906L12.5904 19.8562C12.1971 19.8844 11.8024 19.8844 11.4091 19.8562L9.02789 21.2812C7.6988 20.8613 6.47685 20.1576 5.44664 19.2187L5.49352 16.4437C5.26971 16.1161 5.07221 15.7713 4.90289 15.4125L2.47477 14.0625C2.17632 12.704 2.17312 11.2973 2.46539 9.93747L4.90289 8.58747C5.07022 8.23061 5.26782 7.88873 5.49352 7.5656L5.44664 4.78123C6.47569 3.84351 7.69362 3.13704 9.01852 2.70935L11.4091 4.14373C11.8024 4.1156 12.1971 4.1156 12.5904 4.14373L14.9716 2.71873C16.3007 3.13863 17.5227 3.84237 18.5529 4.78123L18.506 7.5656Z",
				stroke: "#0f172b",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1244_8615",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgGearIcon;
